import { setBackground } from 'common/Prose/Commands/table/mutation'
import { useActiveCellColorsInSelection } from 'common/Prose/hooks/useActiveCellColorsInSelection'
import { type EditorView } from 'prosemirror-view'
import { DEFAULT_BACKGROUND_CELL_COLOR, TABLE_CELL_BACKGROUND_COLOR_OPTIONS } from '../../constants/colorOptions'
import { EditorColorPicker } from '../EditorColorPicker/EditorColorPicker'

interface Props {
  closePicker?: () => void
  includeDropdownStyles?: boolean
  view: EditorView
  focusView?: boolean
}

export const TableCellColorPicker = ({ closePicker, includeDropdownStyles = true, view, focusView = true }: Props) => {
  const activeColors = useActiveCellColorsInSelection(view)

  const setColor = (color: string) => {
    setBackground(color)(view.state, view.dispatch)
    closePicker?.()
    if (focusView) view.focus()
  }

  return (
    <EditorColorPicker
      activeColors={activeColors}
      aria-label={(color) => `Change cell color to ${color}`}
      colorOptions={TABLE_CELL_BACKGROUND_COLOR_OPTIONS}
      defaultColor={DEFAULT_BACKGROUND_CELL_COLOR}
      includeDropdownStyles={includeDropdownStyles}
      noColorButtonPos="bottom"
      noColorButtonLabel="No Color"
      removeColor={() => setColor(DEFAULT_BACKGROUND_CELL_COLOR)}
      setColor={setColor}
      stopPropagation={false}
    />
  )
}
